import React from "react";
import {Col, Input, Row, Select} from "antd";

class FirewallRuleCondition extends React.Component {
    state = {
        field: 'http.request.uri',
        name: '',
        operator: 'EQUALS',
        value: ''
    };

    fields = [
        { value: 'http.host', label: 'Host', placeholder: 'priorityprospect.com' },
        { value: 'http.request.uri', label: 'URI path', placeholder: '/my-path' },
        { value: 'http.request.uri.query', label: 'Query string', placeholder: 'test=value' },
        { value: 'http.request.method', label: 'Request method', placeholder: 'GET' },
        { value: 'http.request.referer', label: 'Referer', placeholder: 'https://priorityprospect.com' },
        { value: 'http.request.user_agent', label: 'User agent', placeholder: 'Firefox' },
        { value: 'http.request.cookie', label: 'HTTP cookie', placeholder: 'name=value' },
        { value: 'http.request.header', label: 'HTTP header' },
        { value: 'http.request.x_forwarded_for', label: 'X-Forwarded-For', placeholder: '8.8.8.8' },
        { value: 'ip.src', label: 'IP address', placeholder: '8.8.8.8' },
        { value: 'ip.cidr', label: 'CIDR', placeholder: '8.8.8.0/24' },
        { value: 'ip.geoip.as', label: 'Autonomous Number', placeholder: '12345' },
        { value: 'ip.geoip.country', label: 'Country', placeholder: '' },
        { value: 'bots.is_bot', label: 'Is bot?', placeholder: '' },
        { value: 'bots.predefined_bot', label: 'Predefined bot', placeholder: '' },
    ];

    operators = [
        { value: 'EQUALS', label: 'Equals' },
        { value: 'NOT_EQUALS', label: 'Does not equal' },
        { value: 'CONTAINS', label: 'Contains' },
        { value: 'NOT_CONTAINS', label: 'Does not contain' },
        { value: 'STARTS_WITH', label: 'Starts with' },
        { value: 'ENDS_WITH', label: 'Ends with' },
        { value: 'REGEX', label: 'REGEX' },
    ];

    http_methods = [
        { value: 'GET', label: 'GET' },
        { value: 'HEAD', label: 'HEAD' },
        { value: 'POST', label: 'POST' },
        { value: 'PUT', label: 'PUT' },
        { value: 'DELETE', label: 'DELETE' },
        { value: 'OPTIONS', label: 'OPTIONS' },
        { value: 'PATCH', label: 'PATCH' },
    ]

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    componentDidMount() {
        this.setState({...this.props.condition});
    }

    updateField(name, value) {
        let data = {[name]: value};
        let operator = this.state.operator;

        if(name === 'field') {
            let listFields = [
                'http.request.method', 'ip.geoip.country', 'bots.predefined_bot', 'bots.is_bot', 'ip.src', 'ip.cidr',
                'ip.geoip.as', 'http.request.x_forwarded_for'
            ];

            if(listFields.indexOf(value) !== -1) {
                data['value'] = [];

                this.operators = [
                    { value: 'EQUALS', label: 'Equals' },
                    { value: 'NOT_EQUALS', label: 'Does not equal' },
                ];

                data['operator'] = 'EQUALS';
                operator = 'EQUALS';
            } else {
                data['value'] = '';

                this.operators = [
                    { value: 'EQUALS', label: 'Equals' },
                    { value: 'NOT_EQUALS', label: 'Does not equal' },
                    { value: 'CONTAINS', label: 'Contains' },
                    { value: 'NOT_CONTAINS', label: 'Does not contain' },
                    { value: 'STARTS_WITH', label: 'Starts with' },
                    { value: 'ENDS_WITH', label: 'Ends with' },
                    { value: 'REGEX', label: 'Regex' },
                ];

                data['operator'] = 'EQUALS';
                operator = 'EQUALS';
            }
        } else if(name === 'operator') {
            operator = value;
        }

        this.setState(data, () => {
            this.props.onChange({ field: this.state.field, name: this.state.name, operator: operator, value: this.state.value });
        });
    }

    getPlaceholder() {
        return this.fields.find(item => item.value === this.state.field)?.placeholder;
    }

    render() {
        let valueField = '';
        let conditionField = '';
        let conditionWidth = 5;
        let valueWidth = 14;

        const { Option } = Select;

        if(this.state.field === 'http.request.method') {
            valueField = <Select style={{width: '100%'}} placeholder={this.getPlaceholder()} options={this.http_methods} value={this.state.value} allowClear mode='multiple' onChange={(value) => this.updateField('value', value)} />;
        } else if(this.state.field === 'ip.geoip.country') {
            valueField = <Select style={{width: '100%'}}
                                 placeholder={this.getPlaceholder()}
                                 allowClear
                                 mode='multiple'
                                 value={this.state.value}
                                 showSearch
                                 filterOption={(input, option) => {
                                     if(typeof option !== 'undefined') {
                                         return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                     }
                                     return false;
                                 }}
                                 onChange={(values) => this.updateField('value', values)}>
                {this.props.countries.map((key) => {
                    return <Option key={key.value} value={key.value}>{key.label}</Option>;
                })}
            </Select>;
        } else if(this.state.field === 'bots.is_bot') {
            valueField = <Select style={{width: '100%'}} placeholder={this.getPlaceholder()} value={this.state.value} onChange={(values) => this.updateField('value', values)}>
                <Option value='TRUE'>True</Option>
                <Option value='FALSE'>False</Option>
            </Select>;
        } else if(this.state.field === 'bots.predefined_bot') {
            valueField = <Select style={{width: '100%'}} placeholder={this.getPlaceholder()} allowClear mode='multiple' options={this.props.predefinedBots} value={this.state.value} onChange={(values) => this.updateField('value', values)} />;
        } else if(this.state.field === 'ip.src' || this.state.field === 'ip.cidr') {
            valueField = <Select style={{width: '100%'}} placeholder={this.getPlaceholder()} allowClear mode='tags' open={false} value={this.state.value} onChange={(values) => this.updateField('value', values)} />;
        } else {
            valueField = <Input style={{width: '100%'}} placeholder={this.getPlaceholder()} value={this.state.value} onChange={(e) => this.updateField('value', e.target.value)} />;
        }

        if(this.state.field === 'http.request.header') {
            conditionWidth = 7;
            valueWidth = 12;

            conditionField = <Row gutter={[16, 16]}>
                <Col span={14}>
                    <Input style={{width: '100%'}} placeholder='Header name, eg: content-type' value={this.state.name} onChange={(e) => this.updateField('name', e.target.value)} />
                </Col>
                <Col span={10}>
                    <Select style={{width: '100%'}} options={this.operators} value={this.state.operator} onChange={(value) => this.updateField('operator', value)} />
                </Col>
            </Row>;
        } else {
            conditionWidth = 5;
            valueWidth = 14;

            conditionField = <Select style={{width: '100%'}} options={this.operators} value={this.state.operator} onChange={(value) => this.updateField('operator', value)} />;
        }

        return <Row gutter={[16, 16]}>
            <Col span={5}>
                <Select
                    style={{width: '100%'}}
                    options={this.fields.filter(item => typeof(this.props.exclude) !== 'undefined' ? !this.props.exclude.includes(item.value) : true)}
                    value={this.state.field}
                    showSearch
                    filterOption={(input, option) => {
                        if(typeof option !== 'undefined') {
                            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }
                        return false;
                    }}
                    onChange={(value) => this.updateField('field', value)} />
            </Col>
            <Col span={conditionWidth}>
                {conditionField}
            </Col>
            <Col span={valueWidth}>
                {valueField}
            </Col>
        </Row>;
    }
}

export default FirewallRuleCondition;